import { Component, Input, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'app-footr',
    templateUrl: './footr.component.html',
    styleUrls: ['./footr.component.scss'],
    standalone: true
})
export class FootrComponent implements OnInit {
  @Input() afterLogin: boolean = true;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateTo(path: string) {
    this.router.navigate([path])
  }

}
